// extracted by mini-css-extract-plugin
export var col = "grid-module--col--gVd3n";
export var container = "grid-module--container--SO4+c";
export var grid = "grid-module--grid--oO3M+";